<template>
  <div class="overlay">
    <div class="mk-fullscreen-search-overlay" id="mk-search-overlay">
      <a href="#" title="Close Site Search" class="mk-fullscreen-close" id="mk-fullscreen-close-button" @click.stop.prevent="closeSiteSearch()"><md-icon>close</md-icon></a>
      <div id="mk-fullscreen-search-wrapper">

  <form id="mk-fullscreen-searchform" autocomplete="off">
  <md-field class="md-autocomplete" :class="fieldClasses" :md-inline="isBoxLayout">
    <label>Search</label>
    <md-menu md-direction="bottom-start" :md-dense="mdDense" md-align-trigger md-full-width>
      <md-input
        @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
        v-model="searchQuery"
        v-bind="$attrs"
        id="mk-fullscreen-search-input"
        :name="name"
        :maxlength="mdInputMaxlength"
        @input="onInput"
      />
      <button v-if="hasValue" class="clear-search" @click.stop.prevent="searchQuery = ''">clear</button>
    </md-menu>

    <slot />
  </md-field>

    <h3 class="_emptyResults" v-if="hasValue && !isPromisePending && isSearchComplete && !hasFilteredItems">No Results Found!</h3>
    
    <div class="md-autocomplete-loading" v-if="isPromisePending">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>

    <div :class="contentClasses" v-show="hasScopedEmptySlot || hasFilteredItems">

      <div class="md-autocomplete-items md-layout" v-if="hasFilteredItems">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-50 md-size-33 result-category-name" v-for="(category, cIndex) in getOptions()" :key="cIndex">
              <h4>{{category.name}} ({{category.items.length}})</h4>
              <ul
                v-if="category.items.length">
                <li class="li-site-search-result" v-for="(item, index) in category.items" :key="index">
                  <a class="site-search-result" v-if="item && item.id" @click="openRecord(category, item)">
                    <template v-for="(dField) in searchConfig[category.name].displayFields">
                      {{ item[dField] | htmlToPlaintext}}
                    </template>
                  </a>
                </li>
              </ul>
              <a class="see-additional-matches" @click="showAdditionalMatches(searchConfig[category.name].searchPath)" v-if="searchConfig[category.name].searchPath && category.showAdditionalFlag ">See additional matches</a>

        </div>
      </div>

      <md-menu-item v-else-if="hasScopedEmptySlot">
        <div class="md-autocomplete-empty">
          <slot name="md-autocomplete-empty" :term="searchQuery" />
        </div>
      </md-menu-item>
    </div>
  </form>
      </div>
    </div>
  </div>

</template>

<script>
  import { searchSite } from '@/graphql/queries_custom';
  import searchConfig from '@/searchConfig';
  import { API, graphqlOperation } from 'aws-amplify';

  import MdPropValidator from 'vue-material/src/core/utils/MdPropValidator'

  export default {
    name: 'Search',
    props: {
      value: {
        type: String,
        default: ''
      },
      mdDense: Boolean,
      mdLayout: {
        type: String,
        default: 'floating',
        ...MdPropValidator('md-layout', [
          'floating',
          'box'
        ])
      },
      mdOpenOnFocus: {
        type: Boolean,
        default: true
      },
      name: String,
      mdInputId: String,
      mdInputMaxlength: [String, Number],
      mdInputPlaceholder: [String, Number]
    },
    filters: {
      htmlToPlaintext: function (text) {
          return  text ? (String(text).replace(/<[^>]+>/gm, '')).replace(/\&nbsp;/g, '') : '';
      }
    },       
    data () {
      return {
        searchQuery: '',
        searchTimeout: null,
        isPromisePending: false,
        isSearchComplete: false,
        filteredAsyncOptions: [],
        searchConfig: searchConfig,
      }
    },
    computed: {
      isBoxLayout () {
        return this.mdLayout === 'box'
      },
      fieldClasses () {
        return this.isBoxLayout? 'md-autocomplete-box' : '';
      },
      contentClasses () {
        if (this.isBoxLayout) {
          return 'md-autocomplete-box-content site-search-results-container'
        } else {
          return 'site-search-results-container'
        }
      },
      hasFilteredItems () {
        return this.filteredAsyncOptions.length > 0
      },
      hasScopedEmptySlot () {
        return this.$scopedSlots['md-autocomplete-empty']
      },
      hasValue () {
        return typeof this.searchQuery !== 'undefined' && this.searchQuery !== "";
      }
    },
    watch: {
      searchQuery (val) {
        // this.isPromisePending = true;
        // this.search(val)
          // .then(options => {
          //   this.filteredAsyncOptions = options
          //   this.isPromisePending = false;
          // })
          // .catch(errors => {
          //
          // })
        clearTimeout(this.searchTimeout);
        this.isSearchComplete = false;

        // this.data.matches.items = [];
        // this.data.matches.total = 0;

        if (val !== "") {
          this.searchTimeout = setTimeout(() => {
            this.search(val)
              .then(options => {
                  this.filteredAsyncOptions = options;
                  this.isPromisePending = false;
                })
          }, 350);
        } 
        else if (val === ""){ 
          this.filteredAsyncOptions = [];
          this.isPromisePending = false;
          this.isSearchComplete = true;
        }
      }
    },
    methods: {
      showAdditionalMatches(path) {
        this.$router.push(path + '?q=' + this.searchQuery);
        this.closeSiteSearch();
      },
      closeSiteSearch() {
        window.document.getElementById('mk-search-overlay').classList.remove("mk-fullscreen-search-overlay-show");
      },
      getOptions () {
        return this.filteredAsyncOptions
      },
      onInput (value) {
        this.$emit('input', value)

        if (this.searchQuery.constructor.toString().match(/function (\w*)/)[1].toLowerCase() !== 'inputevent') {
          this.$emit('md-changed', this.searchQuery)
        }
      },
      async search(searchString) {

        this.isPromisePending = true;
        this.isSearchComplete = false;

        this.$c.log("search(" + searchString + ")");

        let params = {}, operation, response = [];

        if (typeof searchString !== 'undefined' && searchString !== "") {

          searchString = searchString.toLowerCase().trim().replace(/[^a-zA-Z0-9 ]/g, '');
          let searches = searchString.split(" ");


          this.$loopo(this.searchConfig, (searchObject, soName) => {
            if (!searchObject.global) { return }

            let objectName = soName.toLowerCase();
            params[objectName + '_filter'] = {};
            //params[objectName + '_limit'] = 5;
            //params[objectName + '_sort'] = {};
            //params[objectName + '_nextToken'] = "";
            let filters = [];

            searchObject.searchFields.forEach(searchField => {
              let test = {};
              // test[searchField] = {match: searchString};
              // filters.push(test);

              if (searches.length === 1) {
                test = {'query_string': {'default_field': searchField, 'query': '*' + searchString + '*'}};
                filters.push(test);
              } else {
                searches.forEach(term => {
                  test = {'query_string': {'default_field': searchField, 'query': '*' + term + '*'}};
                  filters.push(test);
                });
              }
            });

            this.$c.log("search(" + searchString + ") filters: ", filters);

            // if (filters.length > 1) {
            //   params[objectName + '_filter'] = {or: filters};
            // } else if (filters.length === 1) {
            //   params[objectName + '_filter'] = filters[0];
            // } else {
            //   params[objectName + '_filter'] = null;
            // }
            if (filters.length)
            params[objectName + '_filter'] = {esQuery: JSON.stringify({"bool": {"should": filters, "minimum_should_match": searches.length}})};
          });// End this.$loopo
          params.limit = 6;

          operation = graphqlOperation(searchSite, params);
          this.$c.log("search(" + searchString + ") operation: ", operation);

          let result;
          try {
            result = await API.graphql(operation);
            result = result.data;
          } catch (e) {
            result = e.data;
          }

          Object.keys(result).map(_key => {
            if (null === result[_key]) {
              result[_key] = { items: [], total: 0 };
            }
            const items = [];
            result[_key].items.map((_item, _index) => {
              if (_item && _item.id) {
                items.push(_item);
              }
            });
            result[_key].items = items;
            result[_key].total = items.length;
          });
          result = { data: result };

          this.$c.log("searchResults (raw):", result.data);
          //this code creates the object structure in groups.
          this.$loopo(result.data, (category, catName) => {
            let showAdditionalFlag = false;
            if(category.items.length > 5){
              showAdditionalFlag = true;
              category.items = category.items.splice(1);
            }
            if (typeof category.items !== 'undefined' && category.items.length > 0) {
              let categoryName = catName.substring(0, catName.length - 1).replace('search', '');
              response.push({name: categoryName, items: category.items, showAdditionalFlag: showAdditionalFlag});
            }
          });
          
          this.isPromisePending = false;
          this.isSearchComplete = true;

          this.$c.log("searchResults (formatted):", response);
        }
        return response;
      },
      openRecord(category, item) {
        let path = searchConfig[category.name].recordPath;
        let id = item.id;
        if ('Message' == category.name && item.case && item.case.id) {
          id = item.case.id;
          path = '/cases/{{id}}#'+item.id;
        }
        if ('Comment' == category.name && item.message && item.message.id) {
          id = item.message.messageCaseId;
          path = '/cases/{{id}}#'+item.message.id;
        } else if('Comment' == category.name && item.task && item.task.id){
          id = item.task.id;
          path = '/tasks/{{id}}#'+item.id;
        } else if('Comment' == category.name && item.note && item.note.id){
          id = item.note.case.id;
          path = '/cases/{{id}}#'+item.id;
        }
        if ('Note' == category.name && item.case && item.case.id) {
          id = item.case.id;
          path = '/cases/{{id}}#'+item.id;
        }
        path = path.replace('{{id}}', id);
        let currentPath = this.$route.path+''+this.$route.hash;
        this.$router.push({ path: path })
        if(path == currentPath && this.$route.hash){
          window.$bus.$emit('sidepanel.open');
        }
        this.closeSiteSearch();
      }
    }
  }
</script>

<style lang="scss">
  @import "../../node_modules/vue-material/src/components/MdAnimation/variables";
  @import "../../node_modules/vue-material/src/components/MdElevation/mixins";
  @import "../../node_modules/vue-material/src/components/MdLayout/mixins";

  body,
  html{
    width: 100%;
    height: 100%;
  }

  body #app > .wrapper {
    height: auto;
  }

  .mk-search-trigger {
    position: absolute;
    top: 45%;
    left: 45%;
  }

  .mk-fullscreen-search-overlay #mk-fullscreen-search-wrapper #mk-fullscreen-searchform input[type=submit] {
    position: absolute;
    width: 100px;
    height: 100%;
    background-color: transparent;
    border: 0;
    right: 0;
    top: 0;
  }

  #mk-fullscreen-searchform:focus{
    outline: none;
    border: none;
  }

  .mk-fullscreen-search-overlay #mk-fullscreen-search-wrapper #mk-fullscreen-searchform .fullscreen-search-icon {
    font-size: 25px;
    position: absolute;
    right: 15px;
    width: 25px;
    top: 30px;
    color: #fff;
    color: rgba(255, 255, 255, .2);
    -webkit-transition: all .2s ease-out;
    -moz-transition: all .2s ease-out;
    -ms-transition: all .2s ease-out;
    -o-transition: all .2s ease-out;
    transition: all .2s ease-out;
  }

  .fullscreen-search-icon:hover,
  .fullscreen-search-icon:focus{
    border: none;
    outline: none;
    color: #fff !important;
    -webkit-transition: transform ease-out .2s;
    -moz-transition: transform ease-out .2s;
    -ms-transition: transform ease-out .2s;
    -o-transition: transform ease-out .2s;
    transition: transform ease-out .2s;
    transform: rotate(180deg);
  }

  #mk-fullscreen-searchform {
    position: relative;
    verticle-align: middle;
    top: 0 !important;

    label {
      top: auto;
      bottom: 20px;
    }

    .md-focused label,
    .md-has-value label{
      top: auto;
      bottom: 40px;
    }

    h4 {
      margin-bottom: 5px;
    }

    button.clear-search {
      padding-top: 0;
      padding-bottom: 0;
      line-height: 0;
      height: 20px;
      margin-top: 10px;
      cursor: pointer;
    }
  }

  .mk-fullscreen-search-overlay #mk-fullscreen-search-wrapper #mk-fullscreen-searchform #mk-fullscreen-search-input {
    width: 100%;
    background-color: transparent;
    -webkit-box-shadow: 0 3px 0 0 rgba(255, 255, 255, .1);
    -moz-box-shadow: 0 3px 0 0 rgba(255, 255, 255, .1);
    box-shadow: 0 3px 0 0 rgba(255, 255, 255, .1);
    border: 0;
    text-align: center;
    font-size: 18px !important;
    padding: 20px;
    color: #000;
    -webkit-transition: all .3s ease-out;
    -moz-transition: all .3s ease-out;
    -ms-transition: all .3s ease-out;
    -o-transition: all .3s ease-out;
    transition: all .3s ease-out;
  }

  .mk-fullscreen-search-overlay #mk-fullscreen-search-wrapper #mk-fullscreen-searchform #mk-fullscreen-search-input:focus{
    boder: none;
    outline: none;
  }

  .mk-fullscreen-search-overlay.mk-fullscreen-search-overlay-show {
    visibility: visible;
    opacity: 1;
  }

  .mk-fullscreen-search-overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    visibility: hidden;
    /*background-color: rgba(0, 0, 0, .94);*/
    background-color: rgba(255, 255, 255, .99);
    text-align: center;
    -webkit-transition: all ease-in-out .25s;
    -moz-transition: all ease-in-out .25s;
    -ms-transition: all ease-in-out .25s;
    -o-transition: all ease-in-out .25s;
    transition: all ease-in-out .25s;

    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }

  .mk-animate-element,
  .mk-effect-bg-layer,
  .mk-fullscreen-search-overlay {
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }

  .mk-fullscreen-search-overlay {
    z-index: 9999;
  }

  .mk-fullscreen-search-overlay .mk-fullscreen-close:link,
  .mk-fullscreen-search-overlay .mk-fullscreen-close:visited {
    z-index: 9999;
    color: #000;
  }

  .mk-fullscreen-search-overlay .mk-fullscreen-close {
    position: absolute;
    right: 15px;
    top: 15px;
    font-size: 26px;
    -webkit-transition: transform ease-out .2s;
    -moz-transition: transform ease-out .2s;
    -ms-transition: transform ease-out .2s;
    -o-transition: transform ease-out .2s;
    transition: transform ease-out .2s;
    transform: rotate(0deg);
  }

  .mk-fullscreen-search-overlay.mk-fullscreen-search-overlay-show #mk-fullscreen-search-wrapper {
    opacity: 1;
    visibility: visible;
    -webkit-transform: scale(1);
    -moz-transform: scale(1);
    -ms-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
    ms-transform: scale(1);
  }

  .mk-fullscreen-search-overlay #mk-fullscreen-search-wrapper {
    display: inline-block;
    max-width: 1000px;
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
    vertical-align: middle;
    text-align: left;
    font-size: 16px;
    -webkit-transform: scale(0.9);
    -moz-transform: scale(0.9);
    -ms-transform: scale(0.9);
    -o-transform: scale(0.9);
    transform: scale(0.9);
    ms-transform: scale(0.9);
    opacity: 0;
    visibility: hidden;
    -webkit-transition: all ease-in-out .3s;
    -moz-transition: all ease-in-out .3s;
    -ms-transition: all ease-in-out .3s;
    -o-transition: all ease-in-out .3s;
    transition: all ease-in-out .3s;
  }

  .mk-search-trigger {
    -webkit-transition: color .2s ease-in-out;
    -moz-transition: color .2s ease-in-out;
    -ms-transition: color .2s ease-in-out;
    -o-transition: color .2s ease-in-out;
    transition: color .2s ease-in-out
  }

  #search-button {
    display: relative;
    vertical-align: middle;
    height: 50px;
    width: 40px;
    border: white solid 0.7px;
    border-radius: 50%;
    cursor: pointer;
    opacity: 1;
    padding-right: 10px;
    -webkit-transition: all 400ms;
    -moz-transition: all 400ms;
    -ms-transition: all 400ms;
    -o-transition: all 400ms;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  #search-button i{
    color: white !important;
    font-size: 20px;
    position: absolute;
    left: 15px;
    top: 15px;
  }

  #search-button:hover,
  .mk-fullscreen-close:hover {
    opacity: 0.6;
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transition: all 400ms;
    -moz-transition: all 400ms;
    -ms-transition: all 400ms;
    -o-transition: all 400ms;
  }

  #mk-fullscreen-search-input:focus{
    box-shadow: 0px 3px 0px 0px rgba(255,255,255,0.54) !important;
  }

  .md-autocomplete {
    .md-menu {
      width: 100%;
      display: flex;
    }
  }

  .md-autocomplete-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
  }

  .md-field.md-inline.md-autocomplete-box {
    @include md-elevation(2);
    padding-top: 2px;
    border-radius: 2px;

    &.md-focused {
      z-index: 120;
    }

    &:before,
    &:after {
      display: none;
    }

    .md-toolbar & {
      min-height: 40px;
      height: 40px;
      margin: 0;
      box-shadow: none;
    }

    .md-menu {
      align-items: center;
    }

    .md-input {
      padding-left: 16px;
    }

    &.md-focused label,
    label,
    .md-input-action {
      top: 50%;
      transform: translateY(-50%);
    }

    .md-input-action {
      right: 8px;
    }

    &.md-focused label,
    label {
      margin-top: 2px;
      left: 16px;
    }
  }

  .md-autocomplete-box-content:after {
    height: 6px;
    position: absolute;
    top: -6px;
    right: 0;
    left: 0;
    z-index: 120;
    border-bottom: 1px solid;
    content: "";
  }

  .md-menu-content .md-list .md-list-item a.site-search-result {
    font-size: .9rem;
    text-transform: none;
    color: #4169e1 !important;
  }

  .site-search-results-container.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default {
    width: auto !important;
    min-width: 400px !important;

    .md-autocomplete-items {
      border-bottom: 1px solid lightgray;
      text-align: left;
    }

    .md-list-item-content {
      align-items: flex-start;
    }

    .result-category-name {
      font-size: .9rem;
    }
  }

  .li-site-search-result {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 270px;
    list-style-position: inside;
    margin-left: -20px;
  }
  .see-additional-matches {
    cursor: pointer;
  }

  ._emptyResults {
    text-align: center;
  }

  .site-search-result {
    cursor: pointer;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
.mk-fullscreen-search-overlay::-webkit-scrollbar {
    display: none;
}
</style>
